/* @flow */

import { connect } from 'react-redux';

import squadSelector from 'app/selectors/squadSelector';
import ExportButton from '../commons/ExportButton';
import { isChallengeComplete } from '../../utils/challengeUtils';

const getFields = ({ isRacing, isCompleted }) =>
  isRacing
    ? {
        id: 'Horse ID',
        name: 'Name',
        weight: 'Weight',
        ...(isCompleted
          ? { win: 'Win', place: 'Place' }
          : { winProjected: 'Win', placeProjected: 'Place' }),
        form: 'Form',
        number: 'Runner #',
        leg: 'Leg',
        gameVenue: 'Leg Venue',
        gameNumber: 'Venue Race #',
        playingStatus: 'Playing Status'
      }
    : {
        id: 'Player ID',
        position: 'Position',
        name: 'Name',
        team: 'Team',
        opposition: 'Opponent',
        salary: 'Salary',
        average: 'FPPG',
        form: 'Form',
        playingStatus: 'Playing Status'
      };

const connector = connect(state => {
  const { id, isRacing, statusId } = state.challenge;
  const isCompleted = isChallengeComplete(statusId);

  return {
    autoDownload: true,
    data: squadSelector(state),
    fields: isCompleted
      ? Object.freeze({
          ...getFields({ isRacing, isCompleted }),
          score: 'Score',
          popularity: 'Selected %'
        })
      : Object.freeze(getFields({ isRacing })),
    filename: `players_${id}.csv`,
    isRacing
  };
}, null);

export default connector(ExportButton);
